module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.homeSlides[0] && _vm.homeSlides[0].image) ? _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.homeSlides), function(slide, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": slide.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slider_trans"
    }, [_c('div', {
      staticClass: "slider-caption"
    }, [_c('h2', {
      style: ({
        color: _vm.customization.mainColor,
        'font-size': '1.5em'
      }),
      attrs: {
        "data-swiper-parallax": "-100%"
      }
    }, [_vm._v("\n            " + _vm._s(slide.slideTitle) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "subtitle",
      attrs: {
        "data-swiper-parallax": "-60%"
      }
    }, [_vm._v(_vm._s(slide.slideSubTitle))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "0px"
      },
      attrs: {
        "data-swiper-parallax": "-30%"
      }
    }, [_vm._v("\n            " + _vm._s(slide.slideText) + "\n          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "slide-overlay"
    })])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    style: ([_vm.bottomPosition]),
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c(_vm.bottomMenuComponent, {
    tag: "component",
    attrs: {
      "referralsCount": _vm.historyLoaded ? _vm.referralsCount : null
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15e0ae04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15e0ae04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/home-page-components/varius-component.vue
// module id = 739
// module chunks = 0